export const getGalleryImages = (gallery)=>gallery ? gallery.map((image)=>image.image) : [];
// add a placeholder image if there are no images in the gallery
export const getFormattedGalleryImages = (galleryImages, placeholderImage)=>galleryImages.length === 0 ? [
        placeholderImage
    ] : galleryImages;
// get the default image for the section (ie. if no image is provided, use the placeholder image)
export const getDefaultSectionImage = (section, placeholderImage)=>{
    var ref;
    return ((ref = section[0].image) === null || ref === void 0 ? void 0 : ref.filename) ? section[0].image : placeholderImage;
};
